import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { UserPreferencesApi } from '../../../../core/api/user-preferences/user-preferences-api.service';
import { MobileComponent } from '../../../../shared/components/mobile/mobile.component';

@Component({
  selector: 'app-weather-meteogram',
  templateUrl: './meteogram.component.html',
  styleUrl: './meteogram.component.scss',
})
export class MeteogramComponent extends MobileComponent implements OnInit {
  lastSync: Date = new Date();
  weatherLocation = '';

  constructor(
    breakpointObserver: BreakpointObserver,
    private userPreferencesApi: UserPreferencesApi
  ) {
    super(breakpointObserver);
  }

  ngOnInit(): void {
    this.userPreferencesApi.get().subscribe(prefs => {
      this.weatherLocation = prefs.weatherLocation ?? '';
    });
    setInterval(() => (this.lastSync = new Date()), 300000);
  }

  get src(): string {
    return `https://www.yr.no/en/content/${this.weatherLocation}/meteogram.svg?lastSync=${this.lastSync.getTime()}`;
  }

  get tooltip(): string {
    return `Last synced at ${this.lastSync?.toLocaleTimeString()}`;
  }
}
